function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.56 4a1 1 0 00-1 1v9.56H5a1 1 0 00-1 1v1a1 1 0 001 1h9.56V27a1 1 0 001 1h1a1 1 0 001-1v-9.44H27a1 1 0 001-1v-1a1 1 0 00-1-1h-9.44V5a1 1 0 00-1-1h-1z",
  fill: "currentColor"
})));